import { MESSAGE } from '@/constants'

export const responses = {
  [MESSAGE.RESPONSE_CODE.E_DEFAULT]: 'Sorry, an error occurred',
  [MESSAGE.RESPONSE_CODE.E_INVALID_BECH32_ADDRESS]: 'Sorry the address seems not to be a valid format. Please check it',
  [MESSAGE.RESPONSE_CODE.E_WALLET_NOT_EXISTS]: 'Wallet address error',
  [MESSAGE.RESPONSE_CODE.OK_DEFAULT]: 'Success',
}